import { render, staticRenderFns } from "./EndPoint.vue?vue&type=template&id=451fd992"
import script from "./EndPoint.vue?vue&type=script&lang=js"
export * from "./EndPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451fd992')) {
      api.createRecord('451fd992', component.options)
    } else {
      api.reload('451fd992', component.options)
    }
    module.hot.accept("./EndPoint.vue?vue&type=template&id=451fd992", function () {
      api.rerender('451fd992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/EndPoint.vue"
export default component.exports